export const RECOMMENDATION_TRACKING_KEYS = {
  REC_MODULE_ID: 'rec_module_id',
  REC_ELEMENT_NAME: 'rec_element_name',
  REC_PRODUCT_COUNT: 'rec_product_count',
  IS_CART_MODAL: 'is_cart_modal',
} as const

export type RecommendationTrackingKey = keyof typeof RECOMMENDATION_TRACKING_KEYS

export const RECOMMENDATION_PLACEMENT = {
  CART_POPUP: 'cartPopUp',
  CART_SECTION: 'cartSection',
} as const

export const RECOMMENDATION_LAYOUT = {
  TAB: 'tab',
  CAROUSEL: 'carousel',
} as const

export type RecommendationLayout = (typeof RECOMMENDATION_LAYOUT)[keyof typeof RECOMMENDATION_LAYOUT]
